import React from "react"
import { shape, string } from "prop-types"
import { injectIntl, Link } from "gatsby-plugin-intl"
import styled from "@emotion/styled"
import CardContent from "./card-content"

const propTypes = {
  body: shape(),
  title: string.isRequired,
  fluid: shape(),
  fallbackFluid: shape(),
  slug: string.isRequired,
  intl: shape(),
}

const defaultProps = {
  body: null,
}

const CardLink = styled(Link)`
  color: ${props => props.theme.currentColours.fg};
  text-decoration: none;
`

const Card = ({ body, title, fluid, fallbackFluid, slug, intl }) => (
  <div>
    <CardLink to={`${intl.formatMessage({ id: "product_path" })}/${slug}`}>
      <CardContent
        fluid={fluid}
        fallbackFluid={fallbackFluid}
        body={body}
        title={title}
      />
    </CardLink>
  </div>
)

Card.propTypes = propTypes

Card.defaultProps = defaultProps

export default injectIntl(Card)
